import store from "@/store";
import { PERMISSION_WRITE_QC } from "@/utils/permissions";
import {
  getTenantPrefix,
  resolveTenantIdFromBrowser,
} from "@/utils/tenant";
import { hasValidAuthToken } from "@app/composables/useAuth";

function resolveTenantIdForNavigation() {
  const fromBrowser = resolveTenantIdFromBrowser();
  if (fromBrowser) return fromBrowser;
  const selected = store.getters["tenantId/getSelectedTenant"]?.ID;
  if (selected != null && String(selected).trim() !== "") {
    return String(selected);
  }
  return null;
}

export function guestGuard(to, from, next) {
  if (!hasValidAuthToken(store)) {
    if (to.path !== "/login") return next("/login");
    return next();
  }
  let tenantFromUrl = getTenantPrefix();
  if (!tenantFromUrl || tenantFromUrl === "login") {
    tenantFromUrl = resolveTenantIdFromBrowser();
  }
  if (!tenantFromUrl || tenantFromUrl === "login") {
    const selected = store.getters["tenantId/getSelectedTenant"]?.ID;
    if (selected != null && String(selected).trim() !== "") {
      tenantFromUrl = String(selected);
    }
  }
  if (!tenantFromUrl || tenantFromUrl === "login") {
    if (to.path !== "/login") return next("/login");
    return next();
  }
  return next(`/${tenantFromUrl}/data-management`);
}

export function authGuard(to, from, next) {
  if (!hasValidAuthToken(store)) {
    if (to.path !== "/login") return next("/login");
    return next();
  }

  const tenantPrefix = to.params?.tenantPrefix || getTenantPrefix();
  if (!tenantPrefix) {
    store.commit("tenantId/LOGOUT", undefined, { root: true });
    if (to.path !== "/login") return next("/login");
    return next();
  }

  return next();
}

export function authWithPermission(permission) {
  return async (to, from, next) => {
    if (!hasValidAuthToken(store)) {
      if (to.path !== "/login") return next("/login");
      return next();
    }

    const tenantPrefix = to.params?.tenantPrefix || getTenantPrefix();
    if (!tenantPrefix) {
      store.commit("tenantId/LOGOUT", undefined, { root: true });
      if (to.path !== "/login") return next("/login");
      return next();
    }

    if (permission) {
      let permissions = store.getters["tenantId/getPermissions"];
      if (!permissions?.length) {
        await store.dispatch("tenantId/getUserData");
      }
      if (!store.getters["tenantId/hasPermission"](permission)) {
        return next(`/${tenantPrefix}/data-management`);
      }
    }

    return next();
  };
}

export const requireWriteQc = authWithPermission(PERMISSION_WRITE_QC);

export { resolveTenantIdForNavigation };
